// extracted by mini-css-extract-plugin
export default {"responsive":"SplitByBioModal_responsive_jOoD2"};